import { render, staticRenderFns } from "./RankingExports.vue?vue&type=template&id=04ba4062&"
import script from "./RankingExports.vue?vue&type=script&lang=js&"
export * from "./RankingExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports